import { Injectable } from "@angular/core";

@Injectable()
export class DefaultChartResolutionService {
  private MS_IN_ONE_DAY = 24 * 60 * 60 * 1000;

  public forTimestamp(timestamp: string): { dur: string; last_n: string } {
    const timestampTime = new Date(timestamp).getTime();
    const daysAgo = Math.floor(
      Math.abs(new Date().getTime() - timestampTime) / this.MS_IN_ONE_DAY,
    );

    let dur;
    let lastN;
    if (daysAgo <= 1) {
      dur = "90h/1h";
      lastN = "24";
    } else if (daysAgo <= 7) {
      dur = "90d/1d";
      lastN = "7";
    } else if (daysAgo <= 30) {
      dur = "90d/1d";
      lastN = "30";
    } else {
      dur = "90d/1d";
      lastN = "90";
    }

    return { dur, last_n: lastN };
  }
}
